/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Action, ActionFromJSON,
    InlineResponse2002,
    InlineResponse2002FromJSON,
    InlineResponse2002ToJSON,
    InlineResponse2003,
    InlineResponse2003FromJSON,
    InlineResponse2003ToJSON,
    SiteContactInfo,
    SiteContactInfoFromJSON,
    SiteContactInfoToJSON,
} from '../models';

export interface BannersV1ActionsListRequest {
    search?: string;
    ordering?: string;
    limit?: number;
    offset?: number;
}

export interface BannersV1ListListRequest {
    search?: string;
    ordering?: string;
    limit?: number;
    offset?: number;
}

/**
 * 
 */
export class BannersApi extends runtime.BaseAPI {

    /**
     * Получение списка акций
     */
    async bannersV1ActionsListRaw(requestParameters: BannersV1ActionsListRequest): Promise<runtime.ApiResponse<InlineResponse2002>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
        }

        const response = await this.request({
            path: `/banners/v1/actions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse2002FromJSON(jsonValue));
    }

    /**
     * Получение списка акций
     */
    async bannersV1ActionsList(requestParameters: BannersV1ActionsListRequest): Promise<InlineResponse2002> {
        const response = await this.bannersV1ActionsListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async bannersV1ContactsListRaw(): Promise<runtime.ApiResponse<SiteContactInfo>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
        }

        const response = await this.request({
            path: `/banners/v1/contacts/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteContactInfoFromJSON(jsonValue));
    }

    /**
     */
    async bannersV1ContactsList(): Promise<SiteContactInfo> {
        const response = await this.bannersV1ContactsListRaw();
        return await response.value();
    }

    /**
     */
    async bannersV1ListListRaw(requestParameters: BannersV1ListListRequest): Promise<runtime.ApiResponse<InlineResponse2003>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
        }

        const response = await this.request({
            path: `/banners/v1/list/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse2003FromJSON(jsonValue));
    }

    /**
     */
    async bannersV1ListList(requestParameters: BannersV1ListListRequest): Promise<InlineResponse2003> {
        const response = await this.bannersV1ListListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async bannersV1ActionMainRaw(): Promise<runtime.ApiResponse<Action>> {
        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
        }

        const response = await this.request({
            path: `/banners/v1/action-main/`,
            method: 'GET',
            headers: headerParameters,
            query: {},
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ActionFromJSON(jsonValue.data));
    }

    async bannersV1ActionMain(): Promise<Action> {
        const response = await this.bannersV1ActionMainRaw();
        return await response.value();
    }
}
